// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"310":"37dff366","848":"37dff366"}[chunkId] + ".css";
};